import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { SUBJECT_NOTES_LIST_QUERY } from './getNotesList';
const ADD_NOTE_TO_SUBJECT_MUTATION = gql `
  mutation EP_AddNoteToSubject($subjectID: ID!, $noteID: ID!) {
    ep_addNoteToSubject(subjectID: $subjectID, noteID: $noteID)
  }
`;
export function useAddNoteToSubjectMutation(options) {
    return useGQLMutation(ADD_NOTE_TO_SUBJECT_MUTATION, {
        animateOnSuccess: true,
        refetchQueries: [SUBJECT_NOTES_LIST_QUERY],
        ...options,
    });
}
